export const DOMAIN_UPDATE = 'search/BEDROOM_UPDATE';

export interface IDomain {
  domain: string;
}

interface IDomainAction {
  type: string;
  payload: {
    domain: string;
  };
}

const initialState: IDomain = {
  domain: '',
};

const defaultAction: IDomainAction = {
  type: '',
  payload: {
    domain: 'www',
  },
};

export const domainReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case DOMAIN_UPDATE:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
};

export const setDomain = (domain: string): IDomainAction => {
  return {
    type: DOMAIN_UPDATE,
    payload: {
      domain,
    },
  };
};
